export const SEARCH_RESULT_MODS = `Модификации не найдены`